import { collection, getDocs, doc, updateDoc, query, orderBy, where, deleteDoc, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase';
import { authService } from './authService';

// إنشاء طلب انضمام جديد
export const createJoinRequest = async (requestData) => {
    try {
        const requestsRef = collection(db, 'joinRequests');
        const docRef = await addDoc(requestsRef, {
            ...requestData,
            status: 'قيد الانتظار',
            timestamp: serverTimestamp(),
            createdAt: new Date()
        });
        return {
            success: true,
            requestId: docRef.id
        };
    } catch (error) {
        console.error('Error creating join request:', error);
        throw error;
    }
};

// جلب طلبات التوظيف
export const fetchJoinRequests = async () => {
    try {
        if (!await authService.verifyToken()) {
            throw new Error('يجب تسجيل الدخول أولاً');
        }

        const requestsRef = collection(db, 'joinRequests');
        const q = query(
            requestsRef,
            orderBy('timestamp', 'desc')
        );
        console.log('جاري جلب طلبات التوظيف...');
        const querySnapshot = await getDocs(q);
        console.log('تم العثور على', querySnapshot.size, 'طلب');
        
        const requests = querySnapshot.docs.map(doc => {
            const data = doc.data();
            return {
                id: doc.id,
                ...data,
                name: data.riderName || data.name || 'غير محدد',
                phone: data.riderPhone || data.phone || 'غير محدد',
                experience: data.riderExperience || data.experience || '',
                message: data.message || '',
                status: data.status || 'قيد الانتظار',
                timestamp: data.timestamp?.toDate() || data.createdAt || new Date(),
                hasMotorcycle: data.hasMotorcycle === 'yes',
                hasLicense: !!data.licenseNumber,
                licenseNumber: data.licenseNumber || '',
                age: data.riderAge || data.age || '',
                availability: data.availability || '',
                location: data.location || '',
            };
        });
        
        console.log('طلبات التوظيف:', requests);
        return requests;
    } catch (error) {
        console.error('Error fetching join requests:', error);
        throw error;
    }
};

// تحديث حالة طلب التوظيف
export const updateJoinRequestStatus = async (requestId, status) => {
    try {
        const requestRef = doc(db, 'joinRequests', requestId);
        await updateDoc(requestRef, {
            status: status,
            updatedAt: new Date()
        });
        return true;
    } catch (error) {
        console.error('Error updating join request status:', error);
        throw error;
    }
};

// حذف طلب توظيف
export const deleteJoinRequest = async (requestId) => {
    try {
        const requestRef = doc(db, 'joinRequests', requestId);
        await deleteDoc(requestRef);
        return true;
    } catch (error) {
        console.error('Error deleting join request:', error);
        throw error;
    }
};
